
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Luxuryacseater() {



    const cardData =
    {
        keyword: 'Luxury Ac 32 Seater Tata Bus On Rent in Pune',
        heading: 'Amruta Travels: Luxury Ac 32 Seater Tata Bus On Rent in Pune',
        headingDescription: 'Amruta Travels offers Luxury AC 32 Seater Tata Bus on Rent in Pune, perfect for mid-sized groups seeking both elegance and comfort. Whether it is a wedding, corporate trip, school picnic, or family outing, our 32-seater Tata buses provide a premium travel experience with plush seating, powerful air-conditioning, and smooth performance. With skilled drivers, on-time service, and round-the-clock availability, we ensure your travel is relaxed and enjoyable. Choose Amruta Travels for a seamless, affordable, and luxurious journey across Pune and nearby destinations.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',


  "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Located around 120 km from Pune, Mahabaleshwar is a picturesque hill station in the Western Ghats, known for its cool climate, evergreen forests, and stunning viewpoints such as Arthur’s Seat, Wilson Point (the highest point), and Kate's Point. The region is famous for its strawberry farms, especially during the Strawberry Festival held in spring. Other attractions include Venna Lake for boating, Mapro Garden for strawberry-based treats, and ancient temples like Panchganga and Mahabaleshwar Temple. It's a popular destination for families, honeymooners, and nature enthusiasts seeking a refreshing escape from city life."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range offer a perfect blend of natural beauty and adventure. Lonavala is known for its misty mountains, lush greenery, and monsoon waterfalls like Kune and Bhivpuri. Attractions include Bhushi Dam, Tiger’s Leap, Rajmachi Fort, and Karla & Bhaja Caves. Khandala is equally famous for its panoramic valley views and trekking routes. The area is ideal for a weekend drive, with scenic routes and roadside chikki stalls that add to the charm of this quick getaway."
    },
    {
      "title": "Shirdi",
      "description": "About 190 km from Pune, Shirdi is a sacred town revered by followers of Sai Baba. The Sai Baba Samadhi Mandir is the main attraction, drawing millions of devotees every year. Pilgrims can also visit Dwarkamai, Chavadi, and the Sai Heritage Village. The spiritual ambiance, combined with well-maintained infrastructure and religious events, makes Shirdi a prominent destination for those seeking peace, healing, and spiritual growth."
    },
    {
      "title": "Goa",
      "description": "Located nearly 450 km from Pune, Goa is India’s premier beach destination, known for its lively culture, golden beaches, and Portuguese heritage. From North Goa’s party hotspots like Baga, Anjuna, and Calangute to South Goa’s serene stretches like Palolem and Colva, there’s a vibe for every traveler. Apart from beaches, visitors can explore Aguada Fort, Basilica of Bom Jesus, spice plantations, vibrant flea markets, and indulge in thrilling water sports. Goa is also a haven for foodies, offering authentic seafood, Goan curries, and beachside shacks serving refreshing cocktails."
    },
    {
      "title": "Nashik",
      "description": "Around 210 km from Pune, Nashik is a city of immense cultural, historical, and spiritual significance. It is one of the four cities where the Kumbh Mela is held. Attractions include the ancient Kalaram Temple, Muktidham Temple, Pandavleni Caves, and Trimbakeshwar Temple—an important Jyotirlinga. Nashik is also the wine capital of India, home to Sula Vineyards, York Winery, and many tasting tours. The Godavari River adds to its charm, making it a harmonious blend of spirituality and leisure tourism."
    },
    {
      "title": "Alibaug",
      "description": "Situated about 140 km from Pune, Alibaug is a tranquil coastal town offering a perfect mix of beaches, history, and nature. Popular beaches include Nagaon, Alibaug Beach, and Kashid Beach, all great for swimming, sunbathing, and water sports. The iconic Kolaba Fort, accessible during low tide, adds historical value to the destination. You can also explore Korlai Fort, Kanakeshwar Temple, and local seafood cuisine. Ideal for weekend trips, Alibaug also offers ferry services from Mumbai for added convenience."
    },
    {
      "title": "Kolhapur",
      "description": "Roughly 235 km from Pune, Kolhapur is a vibrant city known for its divine Mahalaxmi Temple, which draws pilgrims throughout the year. The city is equally famous for its spicy cuisine, Kolhapuri chappals, and traditional arts. Attractions include Rankala Lake for evening strolls, Panhala Fort offering panoramic views, and the New Palace Museum showcasing royal heritage. With its rich cultural identity and warm hospitality, Kolhapur is ideal for heritage and culinary tourism."
    },
    {
      "title": "Lavasa",
      "description": "Just 60 km from Pune, Lavasa is an Italian-inspired planned city nestled in the Sahyadri hills. It features beautiful waterfronts, European-style architecture, and a peaceful atmosphere perfect for a quick weekend escape. Activities include kayaking, zip-lining, and lakeside cycling. With cozy resorts, conference centers, and nature trails, Lavasa attracts both families and corporate travelers. The weather remains pleasant most of the year, enhancing its appeal as a rejuvenating destination close to Pune."
    },
    {
      "title": "Satara & Kaas Plateau",
      "description": "About 120 km from Pune, Satara serves as the base for exploring the Kaas Plateau—popularly known as the 'Valley of Flowers' of Maharashtra. The plateau, a UNESCO World Natural Heritage site, bursts into a riot of colors with over 850 species of wildflowers during the monsoon season. Satara is also known for Ajinkyatara Fort, Thoseghar Waterfalls, and Sajjangad Fort. The natural beauty and biodiversity make this region a paradise for trekkers, botanists, and photographers."
    },
    {
      "title": "Aurangabad",
      "description": "Situated 235 km from Pune, Aurangabad is a historical treasure trove, offering insights into ancient art, architecture, and culture. The city is home to the world-famous Ajanta and Ellora Caves, adorned with exquisite carvings and paintings dating back to 2nd century BCE. Other attractions include Bibi Ka Maqbara (a replica of the Taj Mahal), Daulatabad Fort, and Aurangabad Caves. The city is also a gateway to Grishneshwar Jyotirlinga and Paithani saree shopping, making it a must-visit for heritage lovers."
    }
  ],

    "services": [
    {
      "name": "Tata 32 Seater Luxury Bus Hire Pune",
      "description": "Amruta Travels offers Tata 32 Seater luxury bus rentals in Pune, perfect for group travel. Whether it's a corporate event, wedding, or family tour, our luxury buses are equipped with air conditioning, plush seating, and modern amenities to ensure a comfortable and stylish journey."
    },
    {
      "name": "AC 32 Seater Tata Bus Rental",
      "description": "Rent a Tata 32 Seater AC bus for your group travel needs in Pune. Our buses are ideal for corporate outings, family tours, or religious trips, providing air conditioning, comfortable seating, and a smooth ride to any destination."
    },
    {
      "name": "Corporate Luxury Bus 32 Seater in Pune",
      "description": "Travel in luxury for your corporate events with our 32 Seater Tata luxury buses. These buses come equipped with AC, ample legroom, and luxury features, ensuring a comfortable and professional transportation solution for your business needs."
    },
    {
      "name": "32 Seater AC Bus for Wedding Pune",
      "description": "Make your wedding transportation elegant and comfortable with our 32 Seater AC buses. Perfect for transporting guests between wedding venues in Pune, these buses offer comfortable seating, air conditioning, and a smooth ride for your special day."
    },
    {
      "name": "Tata Luxury Coach on Rent Pune",
      "description": "For a high-end travel experience, rent our Tata Luxury Coach in Pune. This luxurious coach is ideal for group travel, offering plush seating, AC, and a comfortable ride for long-distance or local tours. Perfect for corporate events, family outings, or weddings."
    },
    {
      "name": "32 Seater Bus Hire for Family Tour",
      "description": "Rent a Tata 32 Seater bus for your next family tour in Pune. With air conditioning, spacious seating, and ample luggage space, this bus offers a comfortable and enjoyable travel experience for your family gatherings or excursions."
    },
    {
      "name": "Tata 32 Seater Bus for Religious Tour",
      "description": "Book a Tata 32 Seater bus for your religious tour from Pune. Whether you're heading to Shirdi, Pandharpur, or other sacred sites, our buses offer comfort, air conditioning, and reliable service to make your spiritual journey peaceful and comfortable."
    },
    {
      "name": "32 Seater Bus Hire for Corporate Office Event",
      "description": "For your corporate events, rent a Tata 32 Seater bus for a hassle-free travel experience. Ideal for transporting employees or clients to meetings, conferences, or team outings, these buses are equipped with AC, luxury seating, and a smooth ride."
    },
    {
      "name": "Tata 32 Seater AC Bus for School Picnic",
      "description": "Ensure the safety and comfort of students with our Tata 32 Seater AC buses for school picnics. With safety features and comfortable seating, our buses are the perfect choice for educational trips, outings, and field visits from Pune."
    },
    {
      "name": "32 Seater Bus Rental for Pune to Mahabaleshwar",
      "description": "Planning a trip from Pune to Mahabaleshwar? Rent a Tata 32 Seater bus for a comfortable journey. Whether it's a family outing, corporate tour, or group of friends, our buses offer air conditioning, comfortable seating, and a smooth ride."
    },
    {
      "name": "32 Seater Luxury Bus Hire Hadapsar",
      "description": "Looking for a 32 Seater luxury bus rental in Hadapsar? Amruta Travels offers comfortable and stylish Tata 32 Seater buses with air conditioning, ideal for weddings, corporate events, or family trips from Hadapsar to anywhere in Pune or beyond."
    },
    {
      "name": "Tata Bus Rental Kothrud Pune",
      "description": "Rent a Tata 32 Seater bus from Kothrud for your group travel needs. Our buses are perfect for weddings, corporate events, family tours, or religious pilgrimages, offering a comfortable and air-conditioned travel experience across Pune."
    },
    {
      "name": "32 Seater AC Coach Pune to Shirdi",
      "description": "Travel to Shirdi in comfort with our 32 Seater AC Tata buses. Perfect for religious tours, our buses provide ample seating, air conditioning, and a comfortable journey for groups heading to Shirdi from Pune."
    },
    {
      "name": "AC Bus Hire Pune for Group Travel",
      "description": "Rent an AC bus from Amruta Travels for your next group trip in Pune. Whether it’s a family tour, corporate outing, or school trip, our Tata 32 Seater buses offer comfortable seating, air conditioning, and modern amenities for a smooth journey."
    },
    {
      "name": "Wedding Shuttle 32 Seater Bus Tata",
      "description": "Looking for a shuttle service for your wedding? Rent a 32 Seater Tata bus to transport guests between wedding venues in Pune. Our buses come equipped with air conditioning, comfortable seats, and a smooth ride to ensure a stress-free wedding journey."
    }
  ],
  "tableData": [
    ["Tata 32 Seater Luxury Bus Hire Pune", "AC 32 Seater Tata Bus Rental"],
    ["Corporate Luxury Bus 32 Seater in Pune", "32 Seater AC Bus for Wedding Pune"],
    ["Tata Luxury Coach on Rent Pune", "32 Seater Bus Hire for Family Tour"],
    ["Tata 32 Seater Bus for Religious Tour", "32 Seater Bus Hire for Corporate Office Event"],
    ["Tata 32 Seater AC Bus for School Picnic", "32 Seater Bus Rental for Pune to Mahabaleshwar"],
    ["32 Seater Luxury Bus Hire Hadapsar", "Tata Bus Rental Kothrud Pune"],
    ["32 Seater AC Coach Pune to Shirdi", "AC Bus Hire Pune for Group Travel"],
    ["Wedding Shuttle 32 Seater Bus Tata"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Luxury AC 32 Seater Tata Bus on Rent in Pune",
    "WhyChoosedescription": "Amruta Travels offers luxury AC 32 Seater Tata buses on rent in Pune, providing a premium travel experience for small to medium-sized groups. Whether it’s a corporate event, family outing, or a special occasion, our Tata buses offer the comfort and style you deserve."
  },
  {
    "WhyChooseheading": "Premium Comfort for Small to Medium Groups",
    "WhyChoosedescription": "Our luxury 32 Seater Tata buses feature plush, reclining seats, spacious interiors, and advanced air conditioning. Perfect for comfortable long-distance journeys, corporate trips, or elegant wedding guest transport, these buses provide a superior experience."
  },
  {
    "WhyChooseheading": "State-of-the-Art Amenities for an Enjoyable Journey",
    "WhyChoosedescription": "The luxury buses are equipped with top-tier amenities, including high-quality air conditioning, well-cushioned seats, LED lighting, wide windows for scenic views, and modern onboard entertainment, making every trip enjoyable and relaxing."
  },
  {
    "WhyChooseheading": "Clear, Transparent, and Competitive Pricing",
    "WhyChoosedescription": "We offer transparent pricing for our Luxury AC 32 Seater Tata buses. All-inclusive rates cover fuel, tolls, driver charges, taxes, and more—ensuring there are no hidden costs or surprises in your trip budget."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers for Safety and Comfort",
    "WhyChoosedescription": "Our drivers are skilled, licensed, and familiar with all routes in Pune and nearby destinations. They are committed to delivering safe, timely, and comfortable journeys, while offering professional and courteous service throughout your trip."
  },
  {
    "WhyChooseheading": "Ideal for Corporate Trips, Family Getaways, and Weddings",
    "WhyChoosedescription": "The 32 Seater Luxury Tata Bus is perfect for corporate outings, family gatherings, group vacations, or wedding guest transport. Its compact size makes it easy to navigate through city streets while offering luxurious comfort for your group."
  },
  {
    "WhyChooseheading": "Well-Maintained Fleet for Stress-Free Travel",
    "WhyChoosedescription": "Our fleet of Luxury AC 32 Seater Tata buses undergoes regular maintenance and thorough cleaning. We ensure every bus is in top condition for smooth, trouble-free travel, providing you with peace of mind during your journey."
  },
  {
    "WhyChooseheading": "Convenient Booking and Round-the-Clock Customer Support",
    "WhyChoosedescription": "Booking your Luxury AC 32 Seater Tata bus with Amruta Travels is simple. You can reserve online, by phone, or at our office. Our 24/7 customer service team is available to help with any inquiries, booking modifications, or special requests you may have."
  }
]

















    }

const faqData = [
  {
    question: 'Can I rent a Luxury AC 32-seater Tata bus in Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers Luxury AC 32-seater Tata buses for rent in Pune. These buses are perfect for small to medium-sized groups, offering a comfortable, luxurious travel experience for events, outings, and outstation trips.',
  },
  {
    question: 'What amenities are available in the Luxury AC 32-seater Tata bus?',
    answer: 'Our Luxury AC 32-seater Tata buses are equipped with comfortable plush seating, air conditioning, ample legroom, modern entertainment systems, overhead storage, and clean, well-maintained interiors for a premium travel experience.',
  },
  {
    question: 'Is the Luxury AC 32-seater Tata bus available for both local and outstation travel?',
    answer: 'Yes, the Luxury AC 32-seater Tata bus is available for local city travel in Pune as well as outstation trips to popular destinations such as Mumbai, Lonavala, Mahabaleshwar, Shirdi, and other scenic spots.',
  },
  {
    question: 'Is a driver included in the Luxury AC 32-seater Tata bus rental?',
    answer: 'Yes, all Luxury AC 32-seater Tata bus rentals from Amruta Travels include an experienced and licensed driver who ensures the safety, comfort, and timely arrival of all passengers.',
  },
  {
    question: 'How much does it cost to rent a Luxury AC 32-seater Tata bus in Pune?',
    answer: 'Rental charges for the Luxury AC 32-seater Tata bus vary based on distance, trip duration, and services. Generally, rates start from ₹40-₹50 per km. For an accurate quote, please contact us with your travel details.',
  },
  {
    question: 'Is the Luxury AC 32-seater Tata bus comfortable for long journeys?',
    answer: 'Yes, the Luxury AC 32-seater Tata bus is designed for long journeys, providing ample space, air conditioning, and premium seating to ensure a comfortable ride over extended distances.',
  },
  {
    question: 'Are the Luxury AC 32-seater Tata buses well-maintained and sanitized?',
    answer: 'Definitely! All our Luxury AC 32-seater Tata buses are regularly serviced, cleaned, and sanitized before each trip to ensure a hygienic and safe environment for all passengers.',
  },
  {
    question: 'How do I book a Luxury AC 32-seater Tata bus in Pune?',
    answer: 'You can easily book a Luxury AC 32-seater Tata bus online through our website or by contacting our customer support team. We offer quick booking assistance and competitive pricing.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Raghavendra Pillai',
    role: 'Business Executive, Pune',
    text: 'We hired a Luxury AC 32-seater Tata bus from Amruta Travels for a corporate retreat. The bus was extremely comfortable, with top-notch amenities, and the service was exceptional. Highly recommend for group travel!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Shruti Kapoor',
    role: 'Wedding Planner',
    text: 'I booked a Luxury AC 32-seater Tata bus for a destination wedding. The bus was spotless, comfortable, and the air conditioning was perfect for the summer heat. It was a fantastic experience for our guests!',
    rating: 5,
  },
];

























































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury AC 32 Seater Tata Bus on Rent in Pune",
  "image": "https://bushireinpune.com/assets/images/32-seater-tata-bus.jpg",
  "description": "Hire a Luxury AC 32 Seater Tata Bus in Pune for family tours, corporate office events, weddings, and religious trips. Amruta Travels offers comfortable and reliable Tata bus rentals for outstation travel to Mahabaleshwar, Shirdi, and group functions in Hadapsar, Kothrud, and more.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "13546"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4800",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/luxury-ac-32-seater-tata-bus-rent-pune"
  }
};








    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Luxury AC 32 Seater Tata Bus on Rent in Pune | Wedding & Group Travel</title>
  <meta 
    name="description" 
    content="Book a luxury AC 32 seater Tata bus in Pune for corporate travel, school picnics, weddings, or outstation trips to Mahabaleshwar or Shirdi. Comfortable Tata coach rentals by Amruta Travels." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/89.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Luxuryacseater;